import { RemoteGetAllFieldAssessments } from 'data/usecases';
import { makeApiUrlAdminEntity } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllFieldAssessments =
  (): RemoteGetAllFieldAssessments => {
    return new RemoteGetAllFieldAssessments(
      makeApiUrlAdminEntity(),
      makeAxiosHttpClient(),
    );
  };
